import { render } from "./AccountConfirmEmail.vue?vue&type=template&id=2b1c35ba&ts=true"
import script from "./AccountConfirmEmail.vue?vue&type=script&lang=ts"
export * from "./AccountConfirmEmail.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__